const EN = {
  wisdom:
    'The cards reflect the energy around you right now, not a fixed fate. Your future is shaped by every choice you make, and whatever happens, happens for the best.',
  shareTitle: 'NowTarot is free. Help keep it that way 💜',
  shareText: 'If this reading helped, pay it forward and share NowTarot with a friend.',
  shareWithFriend: 'Share with a friend',
  shareSheetTitle: 'NowTarot: free AI tarot readings',
  shareMessage: 'I just got a free tarot reading on NowTarot 🔮 Try it:',
  copyLink: 'Copy link',
  copied: 'Link copied ✓',
  copyPrompt: 'Copy this link:',
  upsellTitle: 'Want a Deeper Reading?',
  upsellBody:
    'Sign up free to save your LLM tarot answers and leave a rating or comment on each reading.',
  upsellCta: 'Sign Up Free — Save Your Readings',
  upsellNote: 'Instant AI tarot chat · No credit card required',
  modalTitle: 'Your Reading',
  askAnother: 'Ask Another Question',
  close: 'Close',
};

const COPY = {
  en: EN,
  es: {
    wisdom:
      'Las cartas reflejan la energía que te rodea ahora, no un destino fijo. Tu futuro se forma con cada decisión que tomas y, pase lo que pase, sucede para bien.',
    shareTitle: 'NowTarot es gratis. Ayuda a que siga así 💜',
    shareText: 'Si esta lectura te ayudó, compártela y pásale NowTarot a un amigo.',
    shareWithFriend: 'Compartir con un amigo',
    shareSheetTitle: 'NowTarot: lecturas de tarot con IA gratis',
    shareMessage: 'Acabo de hacerme una lectura de tarot gratis en NowTarot 🔮 Pruébalo:',
    copyLink: 'Copiar enlace',
    copied: 'Enlace copiado ✓',
    copyPrompt: 'Copia este enlace:',
    upsellTitle: '¿Quieres una lectura más profunda?',
    upsellBody:
      'Regístrate gratis para guardar tus respuestas de tarot con IA y dejar una valoración o un comentario en cada lectura.',
    upsellCta: 'Regístrate gratis — guarda tus lecturas',
    upsellNote: 'Chat de tarot con IA al instante · Sin tarjeta',
    modalTitle: 'Tu lectura',
    askAnother: 'Hacer otra pregunta',
    close: 'Cerrar',
  },
  hi: {
    wisdom:
      'पत्ते अभी आपके आसपास की ऊर्जा दिखाते हैं, कोई तय किस्मत नहीं। आपका भविष्य हर चुनाव से बनता है, और जो भी होता है, अच्छे के लिए होता है।',
    shareTitle: 'NowTarot मुफ़्त है। इसे ऐसा ही रहने दें 💜',
    shareText: 'अगर यह रीडिंग काम आई, तो इसे आगे बढ़ाएँ और NowTarot किसी दोस्त के साथ शेयर करें।',
    shareWithFriend: 'दोस्त के साथ शेयर करें',
    shareSheetTitle: 'NowTarot: मुफ़्त AI टैरो रीडिंग',
    shareMessage: 'मैंने अभी NowTarot पर मुफ़्त टैरो रीडिंग करवाई 🔮 आप भी आज़माएँ:',
    copyLink: 'लिंक कॉपी करें',
    copied: 'लिंक कॉपी हो गया ✓',
    copyPrompt: 'यह लिंक कॉपी करें:',
    upsellTitle: 'और गहरी रीडिंग चाहिए?',
    upsellBody:
      'मुफ़्त साइन अप करें, अपनी AI टैरो रीडिंग सहेजें, और हर रीडिंग पर रेटिंग या टिप्पणी छोड़ें।',
    upsellCta: 'मुफ़्त साइन अप — रीडिंग सहेजें',
    upsellNote: 'तुरंत AI टैरो चैट · क्रेडिट कार्ड की ज़रूरत नहीं',
    modalTitle: 'आपकी रीडिंग',
    askAnother: 'एक और सवाल पूछें',
    close: 'बंद करें',
  },
  zh: {
    wisdom:
      '牌反映的是你此刻周围的能量，不是既定的命运。你的未来由每一次选择塑造，而无论发生什么，都是最好的安排。',
    shareTitle: 'NowTarot 完全免费。帮我们一直免费下去 💜',
    shareText: '如果这次解读对你有帮助，请把它传下去，把 NowTarot 分享给朋友。',
    shareWithFriend: '分享给朋友',
    shareSheetTitle: 'NowTarot：免费 AI 塔罗解读',
    shareMessage: '我刚在 NowTarot 做了一次免费塔罗解读 🔮 你也来试试：',
    copyLink: '复制链接',
    copied: '链接已复制 ✓',
    copyPrompt: '复制这个链接：',
    upsellTitle: '想要更深入的解读？',
    upsellBody: '免费注册，保存你的 AI 塔罗回答，并为每次解读留下评分或评论。',
    upsellCta: '免费注册 — 保存你的解读',
    upsellNote: '即时 AI 塔罗对话 · 无需信用卡',
    modalTitle: '你的解读',
    askAnother: '再问一个问题',
    close: '关闭',
  },
  ar: {
    wisdom:
      'تعكس البطاقات الطاقة المحيطة بك الآن، لا قدرًا ثابتًا. مستقبلك يتشكل بكل اختيار تتخذه، ومهما حدث فهو للخير.',
    shareTitle: 'NowTarot مجاني. ساعدنا على أن يبقى كذلك 💜',
    shareText: 'إذا أفادتك هذه القراءة، مرّرها وشارك NowTarot مع صديق.',
    shareWithFriend: 'شارك مع صديق',
    shareSheetTitle: 'NowTarot: قراءات تاروت مجانية بالذكاء الاصطناعي',
    shareMessage: 'حصلت للتو على قراءة تاروت مجانية على NowTarot 🔮 جرّبها:',
    copyLink: 'نسخ الرابط',
    copied: 'تم نسخ الرابط ✓',
    copyPrompt: 'انسخ هذا الرابط:',
    upsellTitle: 'هل تريد قراءة أعمق؟',
    upsellBody:
      'سجّل مجانًا لتحفظ إجابات التاروت بالذكاء الاصطناعي وتترك تقييمًا أو تعليقًا على كل قراءة.',
    upsellCta: 'سجّل مجانًا — احفظ قراءاتك',
    upsellNote: 'دردشة تاروت فورية بالذكاء الاصطناعي · بلا بطاقة',
    modalTitle: 'قراءتك',
    askAnother: 'اطرح سؤالًا آخر',
    close: 'إغلاق',
  },
  fr: {
    wisdom:
      'Les cartes reflètent l’énergie qui vous entoure en ce moment, pas un destin figé. Votre avenir se construit à chaque choix, et quoi qu’il arrive, c’est pour le mieux.',
    shareTitle: 'NowTarot est gratuit. Aidez-le à le rester 💜',
    shareText: 'Si cette lecture vous a aidé, transmettez-la et partagez NowTarot avec un ami.',
    shareWithFriend: 'Partager avec un ami',
    shareSheetTitle: 'NowTarot : lectures de tarot IA gratuites',
    shareMessage: 'Je viens de faire un tirage de tarot gratuit sur NowTarot 🔮 Essaie :',
    copyLink: 'Copier le lien',
    copied: 'Lien copié ✓',
    copyPrompt: 'Copiez ce lien :',
    upsellTitle: 'Envie d’une lecture plus approfondie ?',
    upsellBody:
      'Inscrivez-vous gratuitement pour enregistrer vos réponses de tarot IA et laisser une note ou un commentaire sur chaque lecture.',
    upsellCta: 'Inscription gratuite — gardez vos lectures',
    upsellNote: 'Chat tarot IA instantané · Sans carte bancaire',
    modalTitle: 'Votre lecture',
    askAnother: 'Poser une autre question',
    close: 'Fermer',
  },
  pt: {
    wisdom:
      'As cartas refletem a energia ao seu redor agora, não um destino fixo. Seu futuro se forma a cada escolha, e aconteça o que acontecer, é para o bem.',
    shareTitle: 'O NowTarot é grátis. Ajude a continuar assim 💜',
    shareText: 'Se esta leitura ajudou, passe adiante e compartilhe o NowTarot com um amigo.',
    shareWithFriend: 'Compartilhar com um amigo',
    shareSheetTitle: 'NowTarot: leituras de tarô com IA grátis',
    shareMessage: 'Acabei de fazer uma leitura de tarô grátis no NowTarot 🔮 Experimente:',
    copyLink: 'Copiar link',
    copied: 'Link copiado ✓',
    copyPrompt: 'Copie este link:',
    upsellTitle: 'Quer uma leitura mais profunda?',
    upsellBody:
      'Cadastre-se grátis para salvar suas respostas de tarô com IA e deixar uma avaliação ou comentário em cada leitura.',
    upsellCta: 'Cadastre-se grátis — salve suas leituras',
    upsellNote: 'Chat de tarô com IA na hora · Sem cartão',
    modalTitle: 'Sua leitura',
    askAnother: 'Fazer outra pergunta',
    close: 'Fechar',
  },
  de: {
    wisdom:
      'Die Karten zeigen die Energie, die dich gerade umgibt, kein festes Schicksal. Deine Zukunft formt sich mit jeder Entscheidung, und was auch geschieht, geschieht zum Guten.',
    shareTitle: 'NowTarot ist kostenlos. Hilf mit, dass es so bleibt 💜',
    shareText: 'Wenn diese Legung geholfen hat, gib sie weiter und teile NowTarot mit einem Freund.',
    shareWithFriend: 'Mit einem Freund teilen',
    shareSheetTitle: 'NowTarot: kostenlose KI-Tarotlegungen',
    shareMessage: 'Ich habe gerade eine kostenlose Tarotlegung auf NowTarot bekommen 🔮 Probier es aus:',
    copyLink: 'Link kopieren',
    copied: 'Link kopiert ✓',
    copyPrompt: 'Kopiere diesen Link:',
    upsellTitle: 'Eine tiefere Legung gewünscht?',
    upsellBody:
      'Melde dich kostenlos an, speichere deine KI-Tarotantworten und hinterlasse zu jeder Legung eine Bewertung oder einen Kommentar.',
    upsellCta: 'Kostenlos anmelden — Legungen speichern',
    upsellNote: 'Sofort-Chat mit KI-Tarot · Keine Kreditkarte',
    modalTitle: 'Deine Legung',
    askAnother: 'Eine weitere Frage stellen',
    close: 'Schließen',
  },
  ja: {
    wisdom:
      'カードが映しているのは、今あなたのまわりにあるエネルギーであり、決まった運命ではありません。未来はあなたの選択の積み重ねで形づくられ、起こることはすべて最善へ向かいます。',
    shareTitle: 'NowTarot は無料です。このまま無料で続けられるよう手伝ってください 💜',
    shareText: 'このリーディングが役に立ったら、友人に NowTarot をシェアしてください。',
    shareWithFriend: '友人にシェア',
    shareSheetTitle: 'NowTarot：無料の AI タロット占い',
    shareMessage: 'NowTarot で無料のタロット占いを受けました 🔮 ぜひ試してみて：',
    copyLink: 'リンクをコピー',
    copied: 'リンクをコピーしました ✓',
    copyPrompt: 'このリンクをコピー：',
    upsellTitle: 'もっと深いリーディングが欲しいですか？',
    upsellBody:
      '無料登録すると、AI タロットの答えを保存でき、リーディングごとに評価やコメントを残せます。',
    upsellCta: '無料登録 — リーディングを保存',
    upsellNote: 'すぐに AI タロットチャット · クレジットカード不要',
    modalTitle: 'あなたのリーディング',
    askAnother: '別の質問をする',
    close: '閉じる',
  },
  ko: {
    wisdom:
      '카드는 정해진 운명이 아니라, 지금 당신 주변의 에너지를 보여 줍니다. 미래는 당신의 선택으로 만들어지고, 어떤 일이 일어나도 최선을 향한 것입니다.',
    shareTitle: 'NowTarot은 무료입니다. 계속 무료로 남을 수 있게 도와 주세요 💜',
    shareText: '이 리딩이 도움이 되었다면, 친구에게 NowTarot을 공유해 주세요.',
    shareWithFriend: '친구에게 공유',
    shareSheetTitle: 'NowTarot: 무료 AI 타로 리딩',
    shareMessage: '방금 NowTarot에서 무료 타로 리딩을 받았어요 🔮 한번 해보세요:',
    copyLink: '링크 복사',
    copied: '링크를 복사했습니다 ✓',
    copyPrompt: '이 링크를 복사하세요:',
    upsellTitle: '더 깊은 리딩을 원하세요?',
    upsellBody:
      '무료로 가입하면 AI 타로 답을 저장하고, 각 리딩에 평점이나 댓글을 남길 수 있습니다.',
    upsellCta: '무료 가입 — 리딩 저장',
    upsellNote: '바로 하는 AI 타로 채팅 · 신용카드 없이',
    modalTitle: '당신의 리딩',
    askAnother: '다른 질문하기',
    close: '닫기',
  },
  it: {
    wisdom:
      'Le carte riflettono l’energia che ti circonda adesso, non un destino fisso. Il tuo futuro prende forma a ogni scelta e, qualunque cosa accada, accade per il meglio.',
    shareTitle: 'NowTarot è gratis. Aiutaci a restare così 💜',
    shareText: 'Se questa lettura ti è stata utile, condividila e passa NowTarot a un amico.',
    shareWithFriend: 'Condividi con un amico',
    shareSheetTitle: 'NowTarot: letture dei tarocchi con IA gratuite',
    shareMessage: 'Ho appena fatto una lettura dei tarocchi gratis su NowTarot 🔮 Provala:',
    copyLink: 'Copia link',
    copied: 'Link copiato ✓',
    copyPrompt: 'Copia questo link:',
    upsellTitle: 'Vuoi una lettura più approfondita?',
    upsellBody:
      'Iscriviti gratis per salvare le risposte dei tarocchi con IA e lasciare un voto o un commento a ogni lettura.',
    upsellCta: 'Iscriviti gratis — salva le letture',
    upsellNote: 'Chat tarocchi con IA subito · Senza carta',
    modalTitle: 'La tua lettura',
    askAnother: 'Fai un’altra domanda',
    close: 'Chiudi',
  },
  tr: {
    wisdom:
      'Kartlar sabit bir kaderi değil, şu an çevrendeki enerjiyi yansıtır. Geleceğin her seçiminle şekillenir ve ne olursa olsun, en iyisi için olur.',
    shareTitle: 'NowTarot ücretsiz. Böyle kalmasına yardım et 💜',
    shareText: 'Bu fal işine yaradıysa, iyiliği ilet ve NowTarot’u bir arkadaşınla paylaş.',
    shareWithFriend: 'Bir arkadaşınla paylaş',
    shareSheetTitle: 'NowTarot: ücretsiz yapay zeka tarot falı',
    shareMessage: 'NowTarot’ta ücretsiz bir tarot falı baktırdım 🔮 Sen de dene:',
    copyLink: 'Bağlantıyı kopyala',
    copied: 'Bağlantı kopyalandı ✓',
    copyPrompt: 'Bu bağlantıyı kopyala:',
    upsellTitle: 'Daha derin bir fal ister misin?',
    upsellBody:
      'Ücretsiz kaydol, yapay zeka tarot yanıtlarını sakla ve her fala puan ya da yorum bırak.',
    upsellCta: 'Ücretsiz kaydol — fallarını sakla',
    upsellNote: 'Anında yapay zeka tarot sohbeti · Kart gerekmez',
    modalTitle: 'Falın',
    askAnother: 'Başka bir soru sor',
    close: 'Kapat',
  },
  id: {
    wisdom:
      'Kartu mencerminkan energi di sekitarmu saat ini, bukan takdir yang sudah pasti. Masa depanmu dibentuk oleh setiap pilihan, dan apa pun yang terjadi, itu untuk kebaikan.',
    shareTitle: 'NowTarot gratis. Bantu agar tetap begitu 💜',
    shareText: 'Jika bacaan ini membantu, teruskan kebaikannya dan bagikan NowTarot ke teman.',
    shareWithFriend: 'Bagikan ke teman',
    shareSheetTitle: 'NowTarot: bacaan tarot AI gratis',
    shareMessage: 'Saya baru saja mendapat bacaan tarot gratis di NowTarot 🔮 Coba juga:',
    copyLink: 'Salin tautan',
    copied: 'Tautan disalin ✓',
    copyPrompt: 'Salin tautan ini:',
    upsellTitle: 'Ingin bacaan yang lebih dalam?',
    upsellBody:
      'Daftar gratis untuk menyimpan jawaban tarot AI dan memberi nilai atau komentar pada setiap bacaan.',
    upsellCta: 'Daftar gratis — simpan bacaanmu',
    upsellNote: 'Chat tarot AI langsung · Tanpa kartu kredit',
    modalTitle: 'Bacaanmu',
    askAnother: 'Ajukan pertanyaan lain',
    close: 'Tutup',
  },
  pl: {
    wisdom:
      'Karty pokazują energię, która otacza cię teraz, a nie ustalony los. Przyszłość kształtuje się z każdym wyborem i cokolwiek się dzieje, dzieje się ku dobremu.',
    shareTitle: 'NowTarot jest darmowy. Pomóż, żeby tak zostało 💜',
    shareText: 'Jeśli ta wróżba pomogła, przekaż ją dalej i podziel się NowTarot ze znajomym.',
    shareWithFriend: 'Udostępnij znajomemu',
    shareSheetTitle: 'NowTarot: darmowe wróżby tarot AI',
    shareMessage: 'Właśnie zrobiłam darmową wróżbę tarota na NowTarot 🔮 Spróbuj:',
    copyLink: 'Kopiuj link',
    copied: 'Link skopiowany ✓',
    copyPrompt: 'Skopiuj ten link:',
    upsellTitle: 'Chcesz głębszą wróżbę?',
    upsellBody:
      'Załóż darmowe konto, zapisuj odpowiedzi tarota AI i zostawiaj ocenę lub komentarz przy każdej wróżbie.',
    upsellCta: 'Załóż konto — zapisuj wróżby',
    upsellNote: 'Czat tarota AI od razu · Bez karty',
    modalTitle: 'Twoja wróżba',
    askAnother: 'Zadaj kolejne pytanie',
    close: 'Zamknij',
  },
  vi: {
    wisdom:
      'Các lá bài phản ánh năng lượng quanh bạn lúc này, không phải một số phận đã định. Tương lai được tạo nên từ mỗi lựa chọn, và chuyện gì xảy ra cũng là để tốt hơn.',
    shareTitle: 'NowTarot miễn phí. Giúp nó mãi miễn phí 💜',
    shareText: 'Nếu bài này hữu ích, hãy truyền tiếp và chia sẻ NowTarot với một người bạn.',
    shareWithFriend: 'Chia sẻ với bạn bè',
    shareSheetTitle: 'NowTarot: xem bài tarot AI miễn phí',
    shareMessage: 'Mình vừa xem một trải bài tarot miễn phí trên NowTarot 🔮 Bạn thử nhé:',
    copyLink: 'Sao chép liên kết',
    copied: 'Đã sao chép liên kết ✓',
    copyPrompt: 'Sao chép liên kết này:',
    upsellTitle: 'Muốn một trải bài sâu hơn?',
    upsellBody:
      'Đăng ký miễn phí để lưu câu trả lời tarot AI và để lại đánh giá hoặc bình luận cho mỗi lần xem.',
    upsellCta: 'Đăng ký miễn phí — lưu bài của bạn',
    upsellNote: 'Chat tarot AI ngay · Không cần thẻ',
    modalTitle: 'Bài của bạn',
    askAnother: 'Hỏi câu khác',
    close: 'Đóng',
  },
  th: {
    wisdom:
      'ไพ่สะท้อนพลังงานรอบตัวคุณในตอนนี้ ไม่ใช่ชะตาที่ตายตัว อนาคตของคุณเกิดจากทุกทางเลือก และไม่ว่าจะเกิดอะไรขึ้น ก็เป็นไปเพื่อสิ่งที่ดีที่สุด',
    shareTitle: 'NowTarot ใช้ฟรี ช่วยให้มันฟรีต่อไป 💜',
    shareText: 'ถ้าคำทำนายนี้ช่วยคุณได้ ส่งต่อและแชร์ NowTarot ให้เพื่อน',
    shareWithFriend: 'แชร์ให้เพื่อน',
    shareSheetTitle: 'NowTarot: ดูดวงไพ่ทาโรต์ AI ฟรี',
    shareMessage: 'เพิ่งได้ดูดวงไพ่ทาโรต์ฟรีบน NowTarot 🔮 ลองดูสิ:',
    copyLink: 'คัดลอกลิงก์',
    copied: 'คัดลอกลิงก์แล้ว ✓',
    copyPrompt: 'คัดลอกลิงก์นี้:',
    upsellTitle: 'อยากได้คำทำนายที่ลึกกว่านี้ไหม?',
    upsellBody:
      'สมัครฟรีเพื่อบันทึกคำตอบทาโรต์ AI และให้คะแนนหรือแสดงความคิดเห็นในแต่ละครั้ง',
    upsellCta: 'สมัครฟรี — บันทึกคำทำนาย',
    upsellNote: 'แชตทาโรต์ AI ทันที · ไม่ต้องใช้บัตร',
    modalTitle: 'คำทำนายของคุณ',
    askAnother: 'ถามคำถามอื่น',
    close: 'ปิด',
  },
  nl: {
    wisdom:
      'De kaarten laten de energie zien die je nu omringt, geen vast lot. Je toekomst krijgt vorm door elke keuze, en wat er ook gebeurt, het is voor het beste.',
    shareTitle: 'NowTarot is gratis. Help het zo te houden 💜',
    shareText: 'Als deze legging hielp, geef het door en deel NowTarot met een vriend.',
    shareWithFriend: 'Delen met een vriend',
    shareSheetTitle: 'NowTarot: gratis AI-tarotleggingen',
    shareMessage: 'Ik heb net een gratis tarotlegging gedaan op NowTarot 🔮 Probeer het:',
    copyLink: 'Link kopiëren',
    copied: 'Link gekopieerd ✓',
    copyPrompt: 'Kopieer deze link:',
    upsellTitle: 'Een diepere legging gewenst?',
    upsellBody:
      'Meld je gratis aan om je AI-tarotantwoorden te bewaren en bij elke legging een beoordeling of reactie achter te laten.',
    upsellCta: 'Gratis aanmelden — bewaar je leggingen',
    upsellNote: 'Directe AI-tarotchat · Geen creditcard',
    modalTitle: 'Jouw legging',
    askAnother: 'Nog een vraag stellen',
    close: 'Sluiten',
  },
  ru: {
    wisdom:
      'Карты отражают энергию вокруг вас сейчас, а не заранее решённую судьбу. Будущее складывается из каждого выбора, и что бы ни случилось, это к лучшему.',
    shareTitle: 'NowTarot бесплатен. Помогите, чтобы так и оставалось 💜',
    shareText: 'Если расклад помог, передайте его дальше и поделитесь NowTarot с другом.',
    shareWithFriend: 'Поделиться с другом',
    shareSheetTitle: 'NowTarot: бесплатные расклады Таро с ИИ',
    shareMessage: 'Я только что сделала бесплатный расклад Таро на NowTarot 🔮 Попробуй:',
    copyLink: 'Копировать ссылку',
    copied: 'Ссылка скопирована ✓',
    copyPrompt: 'Скопируйте эту ссылку:',
    upsellTitle: 'Хотите более глубокий расклад?',
    upsellBody:
      'Зарегистрируйтесь бесплатно, чтобы сохранять ответы ИИ-таро и оставлять оценку или комментарий к каждому раскладу.',
    upsellCta: 'Регистрация — сохраняйте расклады',
    upsellNote: 'Чат с ИИ-таро сразу · Без карты',
    modalTitle: 'Ваш расклад',
    askAnother: 'Задать другой вопрос',
    close: 'Закрыть',
  },
  fil: {
    wisdom:
      'Ipinapakita ng mga baraha ang enerhiya sa paligid mo ngayon, hindi isang nakatakdang kapalaran. Hubog ng bawat pagpili ang iyong hinaharap, at anuman ang mangyari, ito ay para sa ikabubuti.',
    shareTitle: 'Libre ang NowTarot. Tulungan itong manatiling libre 💜',
    shareText: 'Kung nakatulong ang babasang ito, ipasa ito at ibahagi ang NowTarot sa isang kaibigan.',
    shareWithFriend: 'Ibahagi sa kaibigan',
    shareSheetTitle: 'NowTarot: libreng AI tarot reading',
    shareMessage: 'Kakalutas ko lang ng libreng tarot reading sa NowTarot 🔮 Subukan mo:',
    copyLink: 'Kopyahin ang link',
    copied: 'Nakopya ang link ✓',
    copyPrompt: 'Kopyahin ang link na ito:',
    upsellTitle: 'Gusto mo ng mas malalim na babasa?',
    upsellBody:
      'Mag-sign up nang libre para i-save ang mga sagot ng AI tarot at mag-iwan ng rating o komento sa bawat babasa.',
    upsellCta: 'Mag-sign up — i-save ang mga babasa',
    upsellNote: 'Instant na AI tarot chat · Walang credit card',
    modalTitle: 'Ang iyong babasa',
    askAnother: 'Magtanong ng iba',
    close: 'Isara',
  },
  uk: {
    wisdom:
      'Карти показують енергію навколо вас зараз, а не наперед вирішену долю. Майбутнє складається з кожного вибору, і що б не сталося, це на краще.',
    shareTitle: 'NowTarot безкоштовний. Допоможіть, щоб так і лишилося 💜',
    shareText: 'Якщо розклад допоміг, передайте його далі й поділіться NowTarot з другом.',
    shareWithFriend: 'Поділитися з другом',
    shareSheetTitle: 'NowTarot: безкоштовні розклади Таро з ШІ',
    shareMessage: 'Я щойно зробила безкоштовний розклад Таро на NowTarot 🔮 Спробуй:',
    copyLink: 'Копіювати посилання',
    copied: 'Посилання скопійовано ✓',
    copyPrompt: 'Скопіюйте це посилання:',
    upsellTitle: 'Хочете глибший розклад?',
    upsellBody:
      'Зареєструйтеся безкоштовно, щоб зберігати відповіді ШІ-таро і залишати оцінку або коментар до кожного розкладу.',
    upsellCta: 'Реєстрація — зберігайте розклади',
    upsellNote: 'Чат із ШІ-таро одразу · Без картки',
    modalTitle: 'Ваш розклад',
    askAnother: 'Поставити інше запитання',
    close: 'Закрити',
  },
  ro: {
    wisdom:
      'Cărțile reflectă energia din jurul tău acum, nu un destin fix. Viitorul tău se formează cu fiecare alegere, iar orice se întâmplă, se întâmplă spre bine.',
    shareTitle: 'NowTarot este gratuit. Ajută-l să rămână așa 💜',
    shareText: 'Dacă această citire te-a ajutat, dă-o mai departe și împărtășește NowTarot cu un prieten.',
    shareWithFriend: 'Împărtășește cu un prieten',
    shareSheetTitle: 'NowTarot: citiri de tarot cu IA gratuite',
    shareMessage: 'Tocmai am făcut o citire de tarot gratuită pe NowTarot 🔮 Încearcă:',
    copyLink: 'Copiază linkul',
    copied: 'Link copiat ✓',
    copyPrompt: 'Copiază acest link:',
    upsellTitle: 'Vrei o citire mai profundă?',
    upsellBody:
      'Înscrie-te gratuit ca să salvezi răspunsurile de tarot cu IA și să lași o notă sau un comentariu la fiecare citire.',
    upsellCta: 'Înscrie-te gratuit — salvează citirile',
    upsellNote: 'Chat tarot cu IA pe loc · Fără card',
    modalTitle: 'Citirea ta',
    askAnother: 'Pune o altă întrebare',
    close: 'Închide',
  },
  sv: {
    wisdom:
      'Korten speglar energin runt dig just nu, inte ett fast öde. Din framtid formas av varje val, och vad som än händer sker det till det bästa.',
    shareTitle: 'NowTarot är gratis. Hjälp det att förbli så 💜',
    shareText: 'Om den här läsningen hjälpte, för den vidare och dela NowTarot med en vän.',
    shareWithFriend: 'Dela med en vän',
    shareSheetTitle: 'NowTarot: gratis AI-tarotläsningar',
    shareMessage: 'Jag gjorde precis en gratis tarotläsning på NowTarot 🔮 Testa:',
    copyLink: 'Kopiera länk',
    copied: 'Länken kopierad ✓',
    copyPrompt: 'Kopiera den här länken:',
    upsellTitle: 'Vill du ha en djupare läsning?',
    upsellBody:
      'Registrera dig gratis för att spara dina AI-tarotsvar och lämna ett betyg eller en kommentar på varje läsning.',
    upsellCta: 'Registrera dig — spara dina läsningar',
    upsellNote: 'AI-tarotchatt direkt · Inget kort krävs',
    modalTitle: 'Din läsning',
    askAnother: 'Ställ en ny fråga',
    close: 'Stäng',
  },
  cs: {
    wisdom:
      'Karty odrážejí energii, která vás teď obklopuje, ne pevně daný osud. Budoucnost se utváří každým rozhodnutím a ať se stane cokoli, je to k dobrému.',
    shareTitle: 'NowTarot je zdarma. Pomozte, ať to tak zůstane 💜',
    shareText: 'Pokud vám výklad pomohl, pošlete ho dál a sdílejte NowTarot s kamarádem.',
    shareWithFriend: 'Sdílet s kamarádem',
    shareSheetTitle: 'NowTarot: výklady tarotu s AI zdarma',
    shareMessage: 'Právě jsem si nechala udělat výklad tarotu zdarma na NowTarot 🔮 Zkus to:',
    copyLink: 'Kopírovat odkaz',
    copied: 'Odkaz zkopírován ✓',
    copyPrompt: 'Zkopírujte tento odkaz:',
    upsellTitle: 'Chcete hlubší výklad?',
    upsellBody:
      'Zaregistrujte se zdarma, ukládejte odpovědi tarotu s AI a u každého výkladu nechte hodnocení nebo komentář.',
    upsellCta: 'Registrace zdarma — uložte výklady',
    upsellNote: 'Chat s AI tarotem hned · Bez karty',
    modalTitle: 'Váš výklad',
    askAnother: 'Položit další otázku',
    close: 'Zavřít',
  },
  el: {
    wisdom:
      'Τα φύλλα αντικατοπτρίζουν την ενέργεια γύρω σας τώρα, όχι μια προκαθορισμένη μοίρα. Το μέλλον σας πλάθεται με κάθε επιλογή, και ό,τι κι αν συμβεί, είναι για το καλύτερο.',
    shareTitle: 'Το NowTarot είναι δωρεάν. Βοηθήστε να μείνει έτσι 💜',
    shareText: 'Αν αυτή η ανάγνωση βοήθησε, δώστε τη παρακάτω και μοιραστείτε το NowTarot με έναν φίλο.',
    shareWithFriend: 'Κοινοποίηση σε φίλο',
    shareSheetTitle: 'NowTarot: δωρεάν αναγνώσεις ταρώ με ΤΝ',
    shareMessage: 'Μόλις έκανα μια δωρεάν ανάγνωση ταρώ στο NowTarot 🔮 Δοκίμασέ το:',
    copyLink: 'Αντιγραφή συνδέσμου',
    copied: 'Ο σύνδεσμος αντιγράφηκε ✓',
    copyPrompt: 'Αντιγράψτε αυτόν τον σύνδεσμο:',
    upsellTitle: 'Θέλετε μια βαθύτερη ανάγνωση;',
    upsellBody:
      'Εγγραφείτε δωρεάν για να αποθηκεύετε τις απαντήσεις ταρώ με ΤΝ και να αφήνετε βαθμολογία ή σχόλιο σε κάθε ανάγνωση.',
    upsellCta: 'Εγγραφή — αποθηκεύστε τις αναγνώσεις',
    upsellNote: 'Συνομιλία ταρώ με ΤΝ αμέσως · Χωρίς κάρτα',
    modalTitle: 'Η ανάγνωσή σας',
    askAnother: 'Κάντε άλλη ερώτηση',
    close: 'Κλείσιμο',
  },
  hu: {
    wisdom:
      'A kártyák a most körülötted lévő energiát mutatják, nem egy rögzített sorsot. A jövőd minden döntéseddel formálódik, és bármi történik, a javadra történik.',
    shareTitle: 'A NowTarot ingyenes. Segíts, hogy így maradjon 💜',
    shareText: 'Ha ez a vetés segített, add tovább, és oszd meg a NowTarotot egy barátoddal.',
    shareWithFriend: 'Megosztás egy baráttal',
    shareSheetTitle: 'NowTarot: ingyenes AI tarotvetés',
    shareMessage: 'Most csináltattam egy ingyenes tarotvetést a NowTaroton 🔮 Próbáld ki:',
    copyLink: 'Link másolása',
    copied: 'Link másolva ✓',
    copyPrompt: 'Másold ezt a linket:',
    upsellTitle: 'Mélyebb vetést szeretnél?',
    upsellBody:
      'Regisztrálj ingyen, mentsd az AI tarot válaszait, és hagyj értékelést vagy megjegyzést minden vetésnél.',
    upsellCta: 'Ingyenes regisztráció — mentsd a vetéseket',
    upsellNote: 'Azonnali AI tarot csevegés · Bankkártya nélkül',
    modalTitle: 'A vetésed',
    askAnother: 'Új kérdés',
    close: 'Bezárás',
  },
};

const CHROME = {
  en: { outlook: 'Outlook:', analyzing: 'Analyzing your cards…', live: 'Live Reading', complete: 'Reading Complete' },
  es: { outlook: 'Perspectiva:', analyzing: 'Analizando tus cartas…', live: 'Lectura en vivo', complete: 'Lectura lista' },
  hi: { outlook: 'नतीजा:', analyzing: 'आपके पत्ते देखे जा रहे हैं…', live: 'लाइव रीडिंग', complete: 'रीडिंग पूरी' },
  zh: { outlook: '走向：', analyzing: '正在解读你的牌…', live: '实时解读', complete: '解读完成' },
  ar: { outlook: 'التوقّع:', analyzing: 'جارٍ تحليل بطاقاتك…', live: 'قراءة مباشرة', complete: 'اكتملت القراءة' },
  fr: { outlook: 'Perspective :', analyzing: 'Analyse de vos cartes…', live: 'Lecture en direct', complete: 'Lecture terminée' },
  pt: { outlook: 'Perspectiva:', analyzing: 'Analisando suas cartas…', live: 'Leitura ao vivo', complete: 'Leitura pronta' },
  de: { outlook: 'Ausblick:', analyzing: 'Deine Karten werden gelesen…', live: 'Live-Legung', complete: 'Legung fertig' },
  ja: { outlook: '見通し：', analyzing: 'カードを読み解いています…', live: 'ライブリーディング', complete: 'リーディング完了' },
  ko: { outlook: '전망:', analyzing: '카드를 읽고 있습니다…', live: '실시간 리딩', complete: '리딩 완료' },
  it: { outlook: 'Prospettiva:', analyzing: 'Analisi delle tue carte…', live: 'Lettura dal vivo', complete: 'Lettura completata' },
  tr: { outlook: 'Görünüm:', analyzing: 'Kartların okunuyor…', live: 'Canlı fal', complete: 'Fal tamam' },
  id: { outlook: 'Pandangan:', analyzing: 'Kartumu sedang dibaca…', live: 'Bacaan langsung', complete: 'Bacaan selesai' },
  pl: { outlook: 'Perspektywa:', analyzing: 'Odczytywanie kart…', live: 'Wróżba na żywo', complete: 'Wróżba gotowa' },
  vi: { outlook: 'Triển vọng:', analyzing: 'Đang đọc các lá bài…', live: 'Đang xem bài', complete: 'Đã xem xong' },
  th: { outlook: 'แนวโน้ม:', analyzing: 'กำลังอ่านไพ่ของคุณ…', live: 'กำลังทำนาย', complete: 'ทำนายเสร็จแล้ว' },
  nl: { outlook: 'Vooruitzicht:', analyzing: 'Je kaarten worden gelezen…', live: 'Live legging', complete: 'Legging klaar' },
  ru: { outlook: 'Прогноз:', analyzing: 'Читаем ваши карты…', live: 'Расклад в прямом эфире', complete: 'Расклад готов' },
  fil: { outlook: 'Pananaw:', analyzing: 'Binabasa ang mga baraha mo…', live: 'Live na babasa', complete: 'Tapos na ang babasa' },
  uk: { outlook: 'Прогноз:', analyzing: 'Читаємо ваші карти…', live: 'Розклад наживо', complete: 'Розклад готовий' },
  ro: { outlook: 'Perspectivă:', analyzing: 'Se citesc cărțile…', live: 'Citire live', complete: 'Citire gata' },
  sv: { outlook: 'Utsikt:', analyzing: 'Läser dina kort…', live: 'Live-läsning', complete: 'Läsning klar' },
  cs: { outlook: 'Výhled:', analyzing: 'Čteme vaše karty…', live: 'Výklad živě', complete: 'Výklad hotový' },
  el: { outlook: 'Προοπτική:', analyzing: 'Ανάγνωση των φύλλων…', live: 'Ζωντανή ανάγνωση', complete: 'Η ανάγνωση ολοκληρώθηκε' },
  hu: { outlook: 'Kilátás:', analyzing: 'A kártyáid olvasása…', live: 'Élő vetés', complete: 'A vetés kész' },
};

export function readingCopy(lang) {
  const base = COPY[lang] || EN;
  return { ...base, ...(CHROME[lang] || CHROME.en) };
}

export default COPY;
